import { ApplicationFlowTheme } from '../types'
import { getApplicationFlowTheme } from './application-flow-theme'

interface AuthorizeChannelPresentationConfig {

  /** 渠道模板；是授权页展示版本与主题的唯一选择依据。 */
  channelTemplate?: unknown

  /** 对客品牌字段；授权页当前没有独立品牌展示，因此不能参与主题解析。 */
  showChannelName?: unknown
}

export interface AuthorizePresentation {

  /** 由 channelTemplate 映射出的授权皮肤主题。 */
  theme: ApplicationFlowTheme
}

/**
 * resolveAuthorizePresentation — 将渠道详情映射为授权页可消费的 v2 主题。
 * channelTemplate 是唯一的版本和主题来源，showChannelName 不参与颜色或版本推导；
 * 模板不在 2~6 时返回 null，旧授权容器继续展示其原 UI，不由产品或授权类型猜测展示版本。
 * @param {unknown} detail 渠道详情接口返回的原始配置
 * @returns {AuthorizePresentation | null} 有效的 v2 授权主题，或表示沿用旧授权页的 null
 */
export const resolveAuthorizePresentation = (detail: unknown): AuthorizePresentation | null => {
  const config = detail && typeof detail === 'object' ? detail as AuthorizeChannelPresentationConfig : null
  const theme = getApplicationFlowTheme(config?.channelTemplate)

  return theme ? { theme } : null
}
